import script from "./AppConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./AppConfirm.vue?vue&type=script&setup=true&lang=js"

import "./AppConfirm.vue?vue&type=style&index=0&id=1adbcece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1adbcece"]])

export default __exports__